export const TAB_PATHS = {
  TABLE: 'table',
  DASHBOARD: 'dashboard',
};
